export const lemburManagerNameSpec = [
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Manager Name',
    name: 'manager',
    type: 'String',
  },
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Employee Name',
    name: 'EMPLOYEE_NAME',
    type: 'String',
  },
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Employee ID',
    name: 'EMPLOYEE_ID',
    type: 'number',
  },
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Manager Username',
    name: 'managerUsername',
    type: 'String',
  },
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Employee Username',
    name: 'employeeUsername',
    type: 'String',
  },
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Job Position',
    name: 'jobPosition',
    type: 'String',
  },
]
